---
title: 🏕️ ARRL Field Day 2026 📡
date: 2026-06-26
endDate: 2026-06-28
location: TBD — Heyburn State Park or Redtail Campground (McCroskey State Park), Idaho
description: Join DSARC for ARRL Field Day 2026! Arrive Friday, operate Saturday–Sunday as we set up portable stations, make contacts, and demonstrate emergency communications readiness. Location TBD. 📡
published: true
featured: true
---

# 🏕️ ARRL Field Day 2026 📡

<div class="my-6 flex justify-center">
  <img
    src="/images/field-day-2026-logo.jpg"
    alt="ARRL Field Day 2026 Logo"
    class="max-w-sm w-full rounded-lg shadow"
  />
</div>

Join the Do Something Amateur Radio Club for the most popular on-the-air event in North America! Every June, more than 31,000 amateur radio operators set up temporary stations to practice emergency communications, build skills, and showcase ham radio to the public.

---

## 📅 Event Schedule

- **Arrival & Camp Setup:**
  - Friday, June 26, 2026 @ ~12:00 PM PDT
- **Official Field Day Operation:**
  - Saturday, June 27, 2026 @ 11:00 AM PDT (1800 UTC)
  - Sunday, June 28, 2026 @ 1:59 PM PDT (2059 UTC)
- **Breakdown & Departure:**
  - Sunday, June 28, 2026 @ ~3:00 PM PDT

---

## 📍 Location

> **Location is TBD.** We are deciding between **Heyburn State Park** and **Redtail Campground at McCroskey State Park** (where we operated in 2025). Check back for updates or watch our [newsletter](https://dsarc.substack.com) for the announcement.

---

## 🎯 About ARRL Field Day

ARRL Field Day is ham radio's annual "open house" and emergency communications drill. Operators set up temporary stations in less-than-optimal conditions to test their readiness and skills.

**Field Day Goals:**
- Test emergency communication readiness
- Practice setting up and operating portable stations
- Engage the public and showcase ham radio
- Build teamwork and technical skills

**2026 Dates:** June 27–28, 2026 (always the 4th full weekend of June)

---

## 📻 Bands & Modes

- **HF:** 160, 80, 40, 20, 15, and 10 meters
- **VHF/UHF:** All bands 50 MHz and above
- **Restricted:** No activity on 60, 30, 17, or 12 meters
- **Modes:** Any mode supporting the Field Day exchange

---

## 🏆 Bonus Points Reminder

- **+100 pts:** Post to social media with **#ARRLFD** during Field Day
- **+100 pts:** Public location (if applicable)
- **+100 pts:** Media publicity
- **+100 pts:** Natural power (solar, battery, etc.)
- **Entry deadline:** Tuesday, July 28, 2026 via [field-day.arrl.org](https://field-day.arrl.org/fdentry.php)

---

## 🧰 What to Bring

- Your own radio gear — handhelds, mobile rigs, batteries (club will provide HF radios)
- Headset or hand mic (if available)
- Notebook & logging pencils
- Comfortable camp chair and shade shelter
- Water, snacks, and personal items
- Tent or overnight gear (primitive camping; vans/trucks/trailers welcome)
- Warm layers — Idaho nights in late June can be cool

---

## 🎁 Club Will Provide

- HF radios (bring your own too!)
- Antennas, masts, and coax
- Generators and power distribution
- Logging computers and software
- Digital modems
- Snacks and refreshments

---

## 🔗 Resources & Links

- [ARRL Field Day Overview](https://www.arrl.org/field-day)
- [2026 Field Day Rules](https://www.arrl.org/field-day-rules)
- [2026 Field Day Poster (PDF)](https://www.arrl.org/files/file/Field-Day/2026/Field%20Day%202026%20Poster.pdf)
- [Field Day Locator](https://www.arrl.org/field-day-locator)
- [Entry Submission](https://field-day.arrl.org/fdentry.php)
- [ARRL Field Day Facebook Group](https://www.facebook.com/groups/arrlfd/)

---

## 📬 RSVP & Questions

Help us coordinate antennas and food — please RSVP via our [contact page](/contact) or join the conversation on [Discord](https://discord.gg/432vsVAuwZ).